"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "BatchUpdateSegmentsModel", {
    enumerable: true,
    get: function() {
        return BatchUpdateSegmentsModel;
    }
});
const _zod = require("zod");
const _updatemodel = require("../update-model");
const _segmentmodel = require("./segment-model");
const BatchUpdateSegmentsModel = _zod.z.array(_updatemodel.UpdateModel.merge(_segmentmodel.SegmentModel.pick({
    id: true,
    order: true
}))).max(100);

//# sourceMappingURL=batch-update-segments-model.js.map